import type { UserRole } from '@/api/types'

export const ROLE_LABELS: Record<UserRole, string> = {
  superadmin: 'Superadmin',
  admin: 'Admin',
  support: 'Support',
  finance: 'Ekonomi'
}

export function isUserRole(value: string): value is UserRole {
  return value === 'superadmin' || value === 'admin' || value === 'support' || value === 'finance'
}
